import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]
  static values = { template: String }
  declare readonly inputTarget: HTMLInputElement
  declare readonly countTarget: HTMLElement
  declare readonly templateValue: string

  connect() { this.update() }

  update() {
    this.countTarget.textContent = this.templateValue
      .replace("%{current}", String(this.inputTarget.value.length))
      .replace("%{max}", String(this.inputTarget.maxLength))
  }
}
